var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px",class:`card-${_vm.cardType}`},[_c('span',{staticClass:"mr-10px card-title-label"},[_vm._v(" "+_vm._s(_vm.title))]),_vm._t("extend")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }